import { gql } from "@apollo/client";

export const DeleteGrid = gql`
    mutation DeleteGrid($id: ID!) {
        deleteGrid(id: $id) {
            success
            message
        }
    }
`;
